<template>
    <div class="materialInfo" v-loading="loading">
        <div class="materialInfo-header">
            <InfoHeader title="工单素材" @backPage="handleBackPage">
                <div v-if="tagsActive == 1">
                    <el-button
                        type="primary"
                        class="ml40"
                        v-if="getCurAuth('work_order_copy')"
                        @click="handleCopy"
                        plain
                        >复制</el-button
                    >
                    <el-button
                        type="warning"
                        class="ml20"
                        v-if="getCurAuth('withdraw_work_order')"
                        plain
                        @click="handleWithdraw"
                        >撤回</el-button
                    >
                </div>
                <div v-else-if="tagsActive == 2">
                    <el-button
                        type="primary"
                        class="ml20"
                        v-if="getCurAuth('work_order_copy')"
                        @click="handleCopy"
                        plain
                        >复制</el-button
                    >
                    <el-button
                        type="primary"
                        class="ml40"
                        v-if="getCurAuth('download_material')"
                        plain
                        :disabled="is_disabled_download"
                        @click="handleDownload"
                        >下载素材</el-button
                    >
                    <el-button
                        type="primary"
                        class="ml20"
                        v-if="getCurAuth('completion_work_order')"
                        @click="handleSettle"
                        :disabled="is_disabled_finish"
                        >结单</el-button
                    >
                </div>
                <div v-else-if="tagsActive == 3">
                    <el-button
                        type="primary"
                        class="ml40"
                        v-if="getCurAuth('edit_work_order')"
                        @click="handleEdit"
                        plain
                        >修改</el-button
                    >
                    <el-button
                        type="warning"
                        class="ml20"
                        v-if="getCurAuth('withdraw_work_order')"
                        @click="handleWithdraw"
                        >撤回</el-button
                    >
                </div>
                <div v-else-if="tagsActive == 4">
                    <el-button
                        type="primary"
                        class="ml20"
                        v-if="getCurAuth('work_order_copy')"
                        @click="handleCopy"
                        plain
                        >复制</el-button
                    >
                    <el-button
                        type="primary"
                        class="ml40"
                        v-if="getCurAuth('download_material')"
                        plain
                        :disabled="is_disabled_download"
                        @click="handleDownload"
                        >下载素材</el-button
                    >
                </div>
                <div v-else-if="tagsActive == 5">
                    <el-button
                        type="primary"
                        class="ml40"
                        v-if="getCurAuth('work_order_copy')"
                        @click="handleCopy"
                        plain
                        >复制</el-button
                    >
                    <el-button
                        type="primary"
                        class="ml20"
                        v-if="getCurAuth('edit_work_order')"
                        @click="handleEdit"
                        plain
                        >修改</el-button
                    >
                </div>
                <div v-else-if="tagsActive == 6">
                    <el-button
                        type="primary"
                        class="ml40"
                        v-if="getCurAuth('work_order_copy')"
                        @click="handleCopy"
                        plain
                    >复制</el-button>
                    <el-button
                        type="primary"
                        class="ml40"
                        v-if="getCurAuth('download_material')"
                        plain
                        :disabled="is_disabled_download"
                        @click="handleDownload"
                    >下载素材</el-button>
                    <el-button
                        type="primary"
                        class="ml20"
                        v-if="getCurAuth('completion_work_order')"
                        @click="handleSettle"
                        :disabled="is_disabled_finish"
                    >结单</el-button>
                </div>
            </InfoHeader>
        </div>

        <div class="materialInfo-con pt10">
            <div class="left-info">
                <div class="wrap" v-show="show">
                    <div class="info-tabs">
                        <el-tabs v-model="activeName" stretch>
                            <el-tab-pane label="工单信息" name="info">
                                <span slot="label" class="font12px text-bold"
                                    >工单信息</span
                                >
                            </el-tab-pane>
                            <el-tab-pane label="工单流转" name="steps">
                                <span slot="label" class="font12px text-bold"
                                    >工单流转</span
                                >
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="con" v-loading="info_loading">
                        <MaterialInfo
                            :info="info"
                            v-if="activeName == 'info'"
                        />
                        <Materialsteps :stepsList="log" v-else />
                    </div>
                </div>
                <div class="wrap" v-show="!show">
                    <div class="empty-box"></div>
                </div>
                <div class="info-tabs-toggle" @click="handleToggle">
                    <i v-if="show" class="el-icon-caret-left"></i>
                    <i v-else class="el-icon-caret-right"></i>
                </div>
            </div>
            <div class="right-table"><el-row
                    class="table-operations"
                    :class="{ other: listType === 2 }"
                    type="flex"
                    justify="space-between"
                    align="middle"
                >
                    <el-row class="operation-button" type="flex">
                        <el-button
                            type="success"
                            size="mini"
                            v-if="getCurAuth('batch_pass_work_order')"
                            plain
                            @click="handleBatch('approve')"
                            :loading="batchApproveeLoading"
                        >
                            批量通过
                            <el-tooltip
                                effect="dark"
                                content="按任务查看时操作的素材为已选任务的待审核素材，按素材查看时操作的素材为选中的素材"
                                placement="bottom"
                            >
                            <i class="el-icon-question" style="font-size: 16px;"></i>
                            </el-tooltip>
                        </el-button>
                        <el-button
                            type="danger"
                            size="mini"
                            v-if="getCurAuth('batch_deny_work_order')"
                            plain
                            @click="handleBatch('reject')"
                        >
                            批量拒绝
                            <el-tooltip
                                effect="dark"
                                content="按任务查看时操作的素材为已选任务的待审核素材，按素材查看时操作的素材为选中的素材"
                                placement="bottom"
                            >
                            <i class="el-icon-question" style="font-size: 16px;"></i>
                            </el-tooltip>
                        </el-button>
                        <el-button
                            type="primary"
                            size="mini"
                            v-if="getCurAuth('batch_download_material')"
                            plain
                            @click="handleBatch('download')"
                        >
                            批量下载
                        </el-button>
                    </el-row>
                    <el-row
                        class="operation-contant"
                        type="flex"
                        justify="space-between"
                        align="middle"
                    >
                        <el-row type="flex">
                            <div class="search-box custom-input">
                                <el-input
                                    size="mini"
                                    v-model="material_name"
                                    placeholder="请输入素材名称"
                                    @keyup.enter.native="handleSearch('', 'input')"
                                >
                                    <template #prepend>
                                        <div class="pl4 pr4">
                                            <el-select
                                                size="mini"
                                                v-model="material_type"
                                                placeholder="请选择素材类型"
                                                style="width: 100px;"
                                            >
                                                <el-option
                                                    v-for="item in material_type_options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                />
                                            </el-select>
                                         </div>
                                    </template>
                                    <template #append>
                                        <i
                                            class="el-icon-search"
                                            @click="handleSearch('', 'input')"
                                        ></i>
                                    </template>
                                </el-input>
                            </div>
                            <div
                                class="search-box custom-input"
                                v-if="listType === 2"
                            >
                                <span class="prepend">任务</span>
                                <ESelect
                                    size="mini"
                                    :class="{ other: detail_id.length }"
                                    v-model="detail_id"
                                    placeholder="请选择任务"
                                    multiple
                                    collapse-tags
                                    clearable
                                    filterable
                                    @visible-change="(e) => handleSearch(e, 'visible')"
                                    @clear="handleSearch"
                                    @remove-tag="handleSearch"
                                     style="width: 240px;"
                                >
                                    <el-option
                                        v-for="item in taskData"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                    />
                                </ESelect>
                            </div>
                        </el-row>
                        <div class="table-list-type">
                            <el-radio-group v-model="listType" @change="changeListType" size="mini">
                                <el-radio-button :label="1">
                                    
                                    <el-tooltip
                                        effect="dark"
                                        content="按任务查看"
                                        placement="bottom"
                                    >
                                    <i class="el-icon-s-unfold" style="font-size: 16px;"></i>
                                    </el-tooltip>
                                </el-radio-button>
                                <el-radio-button :label="2">
                                    <el-tooltip
                                        effect="dark"
                                        content="素材查看"
                                        placement="bottom"
                                    >
                                    <i class="el-icon-menu" style="font-size: 16px;"></i>
                                    </el-tooltip>
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </el-row>
                </el-row>
                <div class="con scrollbar-wrapper-78778965">
                    <el-table
                        v-if="listType === 1"
                        :data="tableData"
                        :header-cell-style="{
                            background: '#e8eaec',
                            color: '#333',
                        }"
                        style="width: 100%"
                        size="mini"
                        ref="table"
                        row-key="id"
                        :expand-row-keys="expandRowKeys"
                        @expand-change="expandChange"
                        @selection-change="handleSelectable"
                        stripe
                    >
                        <el-table-column
                            type="selection"
                            width="30"
                        ></el-table-column>
                        <el-table-column type="expand" width="40">
                            <template slot-scope="scope">
                                <MaterialsTableExpand
                                    :orderId="scope.row.id"
                                    :rows="scope.row"
                                    :pageFuncNames="pageFuncNames"
                                    :show_status="show_status"
                                    :show-bar="show"
                                    :tagsActive="tagsActive"
                                    @reloadColumn="handleReloadColumn"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column label="任务ID" prop="id" width="80">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.id }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="(待上传，待审核，已通过) / 需求数量"
                            prop="material_num"
                            width="240"
                        >
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    <div
                                        v-if="
                                            scope.row['material_status_num'] ==
                                            '-'
                                        "
                                    >
                                        {{ scope.row["material_status_num"] }}
                                    </div>
                                    <div v-else>
                                        <span
                                            style="
                                                color: #409eff;
                                                cursor: pointer;
                                            "
                                            >({{
                                                scope.row[
                                                    "no_upload_material_num"
                                                ]
                                            }}</span
                                        >，
                                        <span
                                            style="
                                                color: #f56c6c;
                                                cursor: pointer;
                                            "
                                            >{{
                                                scope.row[
                                                    "no_audit_material_num"
                                                ]
                                            }}</span
                                        >，
                                        <span
                                            style="
                                                color: rgb(103, 194, 58);
                                                cursor: pointer;
                                                padding-right: 5px;
                                            "
                                            >{{
                                                scope.row["pass_material_num"]
                                            }})</span
                                        >/
                                        <span style="">{{
                                            scope.row["material_num"]
                                        }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="制作人" prop="producer_name">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)" :title="scope.row.producer_name" class="ellipsis">
                                    {{ scope.row.producer_name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="制作完成日期"
                            prop="finish_time"
                            width="100"
                        >
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.finish_time }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="任务紧急程度"
                            prop="urgent_level"
                            width="100"
                        >
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    <span
                                        v-if="scope.row['urgent_level'] == 2"
                                        style="color: #ff0000"
                                        >{{
                                            scope.row["urgent_level_text"]
                                        }}</span
                                    >
                                    <span v-else>{{
                                        scope.row["urgent_level_text"]
                                    }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="媒体" prop="plat_name">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.plat_name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="素材格式"
                            prop="material_format"
                        >
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.material_format }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="素材尺寸">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.width }} *
                                    {{ scope.row.height }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="素材大小">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    <={{ scope.row.material_size }}
                                    {{ scope.row.material_size_unit }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--                    <div class="tar pt10" style="background-color: #fff;">-->
                    <!--                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
                    <!--                                       :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"-->
                    <!--                                       layout="total, sizes, prev, pager, next, jumper" :total="total">-->
                    <!--                        </el-pagination>-->
                    <!--                    </div>-->
                    <div v-else>
                        <MaterialsTableExpand
                            ref="materialsRef"
                            :orderId="order_id"
                            :params="{ [material_type]: material_name, detail_id }"
                            :pageFuncNames="pageFuncNames"
                            :show_status="show_status"
                            :show-bar="show"
                            :tagsActive="tagsActive"
                            @reloadColumn="handleReloadColumn"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InfoHeader from "@/views/workOrder/components/infoHeader.vue"
import MaterialExtendItem from "@/views/workOrder/components/materialExtendItem.vue"
import MaterialInfo from "./info.vue"
import Materialsteps from "@/views/workOrder/components/steps.vue"
import MaterialsTableExpand from "./tableExpand.vue"
import API from "@/api/workOrder/material.js"
import {
    withdrawModal,
    downLoadModal,
    settleModel,
    rejectModal,
    resultModal,
    filterNullRejectModal,
} from "../modalMaterial"
import { mapState, mapActions, mapMutations } from "vuex"
import { find } from "lodash"
import matomoFun from "@/utils/matomo.js"
export default {
    name: "materialInfo",
    components: {
        MaterialExtendItem,
        InfoHeader,
        MaterialInfo,
        Materialsteps,
        MaterialsTableExpand,
    },
    props: {
        pageFuncNames: Array,
        reload: {
            type: String,
            default: "",
        },
        query: {
            type: Object,
            default: function () {
                return {}
            },
        },
    },
    data() {
        return {
            show: true,
            activeName: "info",
            activeTableExpandName: "ready",
            info: [], //工单信息
            log: [], //工单流转
            tableData: [],
            expandParams: {},
            loading: false,
            info_loading: false,
            order_id: "",
            is_disabled_download: false,
            is_disabled_finish: false,
            expandRowKeys: [],
            show_type: false,
            show_status: "",
            tagsActive: "",
            tags: [
                {
                    value: "1",
                    label: "待指派",
                },
                {
                    value: "2",
                    label: "制作中",
                },
                {
                    value: "3",
                    label: "被驳回",
                },
                {
                    value: "4",
                    label: "已完成",
                },
                {
                    value: "5",
                    label: "已撤回",
                },
            ],
            listType: 1,
            multipleSelection: [],
            batchApproveeLoading: false,
            detail_id: [],
            material_name: "",
            taskData: [],
            material_type: "material_name",
            material_type_options: [
                {
                    value: 'material_name',
                    label: '素材名称'
                },
                {
                    value: 'material_md5',
                    label: '素材md5'
                },
            ]
        }
    },
    computed: {
        // 计算表格高度为视口高度减去160像素
        tableHeight() {
            return `calc(100vh - 212px)`
        },
        ...mapState({
            uploadQueue: (state) => state.workOrder.workTaskList,
        }),
    },
    watch: {
        query: {
            handler(n, o) {
                const { id, tagsActive, show_type } = n
                this.order_id = id
                this.show_type = show_type
                this.show_status = n?.show_status ? n?.show_status : ""
                // this.tagsActive = tagsActive
                if(id){
                    this.fetchInfo(id)
                    this.fetchLog(id)
                    this.fetchDetail(id)
                    this.fetchTaskData(id)
                }
                

                // setTimeout(()=>{
                //     if(Object.keys(this.$route.query).length != 0) {
                //         this.$router.path({name:'work_order_material', query:{}})
                //     }
                // },100)
            },
            deep: true,
            immediate: true,
        },
        tagsActive: {
            handler(val) {
                // let name_list = this.tags.filter(item=>item.value == val)
                // let cur_name = '待指派'
                // if(name_list && name_list.length !== 0 && val) {
                //     cur_name = name_list[0].label
                // }
                this.CHANGE_BREADCRUMB(["工单管理", "工单详情"])
            },
            immediate: true,
        },
    },
    mounted() {},
    methods: {
        ...mapActions("workOrder", ["ADD_ROUTE_LIST", "READ_ROUTE_LIST"]),
        ...mapMutations("app", ["CHANGE_BREADCRUMB"]),
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name)
        },
        fetchInfo(id) {
            this.info_loading = true
            API.getWorkOrderInfo({ order_id: id })
                .then(
                    (res) => {
                        this.info = res.data
                        this.tagsActive = res.data.order_status
                        this.is_disabled_download = res.data
                            .is_disabled_download
                            ? true
                            : false
                        this.is_disabled_finish = res.data.is_disabled_finish
                            ? true
                            : false
                    },
                    (err) => {
                        this.$message.error(err.info)
                    }
                )
                .finally(() => {
                    this.info_loading = false
                })
        },
        fetchLog(id) {
            API.getWorkOrderLog({ order_id: id }).then(
                (res) => {
                    this.log = res.data
                },
                (err) => {
                    this.$message.error(err.info)
                }
            )
        },
        fetchDetail(id) {
            if (this.listType === 1) {
                this.loading = true
                API.getWorkOrderDetailList({ order_id: id })
                    .then(
                        (res) => {
                            this.tableData = res.data
                            if (
                                this.show_type &&
                                this.show_type.toString() === "true"
                            ) {
                                this.$nextTick(() => {
                                    this.expandRowKeys = this.tableData.map(
                                        (item) => {
                                            return item.id
                                        }
                                    )
                                    //   this.expandRowKeys.forEach((item)=> {
                                    //       this.fetchMaterialList(item)
                                    //   })
                                })
                            }
                        },
                        (err) => {
                            this.$message.error(err.info)
                        }
                    )
                    .finally(() => {
                        this.loading = false
                    })
            } else {
                this.$nextTick(() => {
                    this.$refs.materialsRef.fetchInfo("", "init")
                })
            }
        },
        fetchMaterialList(id) {
            API.getWorkOrderMaterialList({ detail_id: id }).then((res) => {
                this.expandParams = res.data
                // this.$refs.table.toggleRowExpansion()
            })
        },
        fetchTaskData(id) {
            API.getWorkOrderTaskFilterData({ order_id: id }).then((res) => {
                this.taskData = res.data || []
            })
        },
        pushMatomo(name) {
            let cur_name = find(
                this.tags,
                (item) => item.value == this.query.tagsActive
            )
            let behaviorCategory = `素材工单(工单管理-${cur_name?.label})`
            matomoFun.trackEvent(behaviorCategory, "点击", name)
        },
        // 返回上一页
        handleBackPage() {
            // let result = this.READ_ROUTE_LIST().then(res=>{
            //     this.$router.push({
            //         name:'work_order_material',
            //         query: res,
            //         params:{
            //             menuReload: 1
            //         }
            //     });
            // })
            this.pushMatomo("查看(返回)")
            if (window.history.length > 1) {
                this.$router.go(-1)
            } else {
                this.$router.replace({
                    name: "work_order_material",
                    query: {
                        topage: "MaterialPage",
                    },
                    params: {
                        menuReload: 1,
                    },
                })
            }
            // this.$emit('changePage','MaterialPage',{});
        },
        // 工单信息与流转 展开收起
        handleToggle() {
            this.show = !this.show
        },
        // 撤回 弹框
        handleWithdraw() {
            const { vm } = withdrawModal({
                props: {
                    id: this.order_id,
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                        // this.$emit('changePage', 'MaterialPage', {}, 'edit');
                        let current_tags = this.query.tagsActive
                            ? this.query.tagsActive.toString()
                            : this.tagsActive
                        this.$router.replace({
                            name: "work_order_material",
                            query: {
                                topage: "MaterialPage",
                                reload: "edit",
                                tagsActive: current_tags ? current_tags : "1",
                            },
                            params: {
                                menuReload: 1,
                            },
                        })
                    },
                },
            })
        },
        // 下载 弹框
        handleDownload() {
            const { vm } = downLoadModal({
                props: {
                    orderId: [this.order_id],
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                    },
                },
            })
        },
        // 结单 弹框
        handleSettle() {
            let isEqul = this.uploadQueue.some(
                (item) => item.order_id == rows.order_id
            )
            if (isEqul) {
                return this.$message.warning(
                    "该任务正再上传素材，无法继续操作，素材上传完成后可继续操作"
                )
            }
            const { vm } = settleModel({
                props: {
                    id: this.order_id,
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                        let current_tags = this.query.tagsActive
                            ? this.query.tagsActive.toString()
                            : this.tagsActive
                        this.$router.replace({
                            name: "work_order_material",
                            query: {
                                topage: "MaterialPage",
                                reload: "edit",
                                tagsActive: current_tags ? current_tags : "1",
                            },
                            params: {
                                menuReload: 1,
                            },
                        })
                    },
                },
            })
        },
        // 展开行
        expandChange(row, expandeRows) {},
        toggleRowExpansion(row) {
            this.$refs.table.toggleRowExpansion(row)
        },
        handleEdit() {
            // this.$emit('changePage','createPage',{order_id: this.query.order_id, work_order_create_type: 'edit',fromPage: 'MaterialInfoPage', tagsActive:this.query.tagsActive});
            this.handleToPage("edit")
        },
        handleCopy() {
            // this.$emit('changePage','createPage',{order_id: this.query.order_id, work_order_create_type: 'copy',fromPage: 'MaterialInfoPage', tagsActive:this.query.tagsActive});
            this.handleToPage("copy")
        },
        //更新单个column
        handleReloadColumn(id) {
            console.log("id制作中", id)
            API.getWorkOrderDetailList({ order_id: this.order_id }).then(
                (res) => {
                    let currentIndex = res.data.findIndex(
                        (item) => item.id == id
                    )
                    if (currentIndex !== -1) {
                        this.$set(
                            this.tableData,
                            currentIndex,
                            res.data[currentIndex]
                        )
                    }
                },
                (err) => {
                    this.$message.error(err.info)
                }
            )
        },
        handleToPage(type) {
            this.ADD_ROUTE_LIST(this.query)
            let current_tags = this.query.tagsActive
                ? this.query.tagsActive.toString()
                : this.tagsActive
            this.$router.push({
                name: "work_order_material",
                query: {
                    formpage: "MaterialPage",
                    topage: "CreatePage",
                    order_id: this.order_id,
                    tagsActive: current_tags ? current_tags : "1",
                    actionType: type,
                },
                params: {
                    menuReload: 1,
                },
            })
        },
        handleSelectable(val) {
            this.multipleSelection = val
        },
        // 批量拒绝/通过/下载
        handleBatch(status) {
            if (this.listType === 1) {
                if (!this.multipleSelection.length) {
                    return this.$message.warning("请选择任务")
                }
                const detailIds = this.multipleSelection.map((row) => row.id) // 提取选中任务的ID
                if (status === "approve") {
                    // 通过
                    this.$confirm(
                        `已选择${detailIds.length}条数据，您确定要通过吗？`,
                        "提示",
                        {
                            confirmButtonText: "通过",
                            type: "warning",
                        }
                    ).then(() => {
                        this.batchApproveeLoading = true
                        API.postWorkOrderBatchPass({
                            detail_id: detailIds,
                        }).then(
                            (res) => {
                                this.multipleSelection = []
                                this.batchApproveeLoading = false
                                this.fetchDetail(this.order_id)
                            },
                            (err) => {
                                this.batchApproveeLoading = false
                                this.$message.error(err.info)
                            }
                        )
                    })
                } else if (status === "reject") {
                    // 拒绝
                    const { vm } = rejectModal({
                        props: {
                            type: "group",
                            detailId: detailIds,
                        },
                        cbs: {
                            onSubmit: (data) => {
                                vm.close()
                                this.multipleSelection = []
                                this.fetchDetail(this.order_id)
                            },
                        },
                    })
                } else if (status === "download") {
                    const { vm } = downLoadModal({
                        props: {
                            orderId: [this.order_id],
                            detailId: detailIds, // 传递任务ID数组给下载弹框
                        },
                        cbs: {
                            onSubmit: () => {
                                vm.close()
                            },
                        },
                    })
                }
            } else {
                if (status === "approve") {
                    this.$refs.materialsRef.handleGroupPass()
                } else if (status === "reject") {
                    this.$refs.materialsRef.handleGroupReject("group")
                } else if (status === "download") {
                    this.$refs.materialsRef.handleGroupDown()
                }
            }
        },
        changeListType() {
            this.multipleSelection = []
            // this.listType = this.listType === 1 ? 2 : 1
        },
        handleSearch(e, status) {
            if (status === "visible" && e === true) return
            this.multipleSelection = []
            if (status === "input" && this.material_name) {
                this.listType = 2
            }
            // if (status === "input" && !this.material_name && !this.detail_id.length) {
            //     this.listType = 1
            // }
            this.fetchDetail(this.order_id)
        }
    },
}
</script>
<style lang="scss" scoped>
.materialInfo {
    ::v-deep .el-table::before{
        display: none;
    }

    .materialInfo-con {
        height: calc(100vh - 100px);
        width: 100%;
        display: flex;
        justify-content: space-between;

        .left-info {
            height: 100%;
            margin-right: 10px;
            position: relative;

            .info-tabs-toggle {
                position: absolute;
                right: -10px;
                top: 50%;
                transform: translateY(-50%);
                width: 10px;
                height: 80px;
                background-color: #409eff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                i {
                    color: #fff;
                }
            }

            .wrap {
                display: flex;
                flex-direction: column;
                height: 100%;

                .info-tabs {
                    background-color: #fff;
                    width: 100%;
                    text-align: center;
                }

                .con {
                    background-color: #fff;
                    width: 200px;
                    padding: 0 6px;
                    height: 0;
                    flex: 1;
                    overflow: auto;
                }
            }

            ::v-deep .el-tabs__item {
                line-height: 32px;
                height: 36px;
            }
        }

        .right-table {
            flex: 1;
            padding: 8px;
            background: #fff;
            overflow-x: hidden;
            height: 100%;
            display: flex;
            flex-direction: column;

            .con {
                background-color: #fff;
                height: 100%;
                flex: 1;
                overflow: hidden;
                > div {
                    height: 100%;
                    overflow: auto;
                }
            }

            ::v-deep .el-table__expanded-cell {
                background-color: #f2f2f2 !important;
            }

            .table-operations {
                flex-wrap: wrap;
                padding-bottom: 2px;
                background-color: #fff;

                > .el-row {
                    margin-bottom: 8px;
                }

                .operation-button {
                    margin-right: 8px;
                }

                .operation-contant {
                    flex: auto;

                    .search-box {
                        height: 30px;
                        display: flex;
                        align-items: center;
                        ::v-deep .el-input-group__prepend {
                            padding: 0 10px;
                            &::after {
                                border-color: #dcdfe6 !important;
                            }
                        }

                        ::v-deep .el-input-group__append {
                            cursor: pointer;
                            padding: 0 8px;
                            background: #f5f7fa !important;
                        }

                        .other {
                            ::v-deep .el-tag {
                                max-width: calc(100% - 30px) !important;
                            }

                            ::v-deep .el-select__input {
                                padding: 0 4px !important;
                                margin-left: 4px !important;
                                max-width: 30px !important;
                            }
                        }
                    }

                    .custom-input {
                        margin-right: 10px;
                    }

                    .prepend {
                        flex: 1 0 auto;
                        height: 100%;
                        line-height: 28px;
                        &::after {
                            border-color: #dcdfe6 !important;
                        }
                    }
                }

                .table-list-type {
                    // width: 26px;
                    text-align: center;

                    img {
                        height: 20px;
                        cursor: pointer;
                        transition: transform 0.3s ease;

                        &:hover {
                            transform: scale(1.2);
                        }
                    }
                }

                &.other {
                    margin-bottom: 4px;
                    border-bottom: 1px solid #dcdfe6;
                }
            }
        }

        .empty-box {
            width: 3px;
            border: solid 1px #ccc;
            height: 100%;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    width: 200px;
    opacity: 1;
    transition: all 0.6s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
    width: 0;
    opacity: 0;
}

.material-table-expand {
    padding: 0 10px;

    .material-table-expand-con {
        //background-color: #F1F4F9;
    }

    .material-table-expand-header {
        display: flex;
        flex-wrap: wrap;

        span {
            padding-right: 20px;
            padding-bottom: 6px;
        }
    }

    .material-table-expand-cards {
        display: flex;
        flex-wrap: wrap;

        .pad-material-table-expand-cards-item {
            background-color: transparent !important;
            width: 300px;
        }

        .material-table-expand-cards-item {
            background-color: #fff;
            margin: 0 5px 10px 5px;
        }
    }
}

.tabsMini {
    background-color: #fff;
    padding-left: 20px;

    .el-tabs__item {
        font-size: 12px;
        line-height: 30px;
        height: 30px;
    }
}

::v-deep .el-table-column--selection .cell {
    padding-left: 8px !important;
    padding-right: 8px !important;
}
</style>
